import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
	selector: 'app-selector',
	templateUrl: './selector.component.html',
	styleUrls: ['./selector.component.scss']
})
export class SelectorComponent {
	@Input() form: FormGroup;
	@Input() label: string;
	@Input() placeholder: string;
	@Input() formName: string;
	@Input() selectionArray: Array<string>;
	@Input() IsArrayObject: boolean = false;
	@Input() showValidationError: boolean = true;
	@Input() serverSearch: boolean = true;

	@Output() ngModelChange = new EventEmitter<any>();
	@Output() onSearch = new EventEmitter<any>();

	constructor() {}

	handleOnModelChange($event){
    // ... all of your logic
    this.ngModelChange.emit($event); // this will pass the $event object to the parent component.
	}

	handleOnSearch($event){
    // ... all of your logic
    this.onSearch.emit($event); // this will pass the $event object to the parent component.
	}

}
